export default "__VITE_ASSET__3825d453__"